<template>
  <div class="card floating">
    <div class="card-title">
      <h2>{{ $t('prompts.copy') }}</h2>
    </div>

    <div class="card-content">
      <p>{{ $t('prompts.copyMessage') }}</p>
      <file-list @update:selected="val => dest = val"></file-list>
    </div>

    <div class="card-action">
      <button class="button button--flat button--grey" id ="buttonCancelCopy"
        @click="$store.commit('closeHovers')"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')">{{ $t('buttons.cancel') }}</button>
      <button class="button button--flat" id ="buttonCopy"
        @click="copy"
        :disabled="req.url === dest"
        :aria-label="$t('buttons.copy')"
        :title="$t('buttons.copy')">{{ $t('buttons.copy') }}</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import FileList from './FileList.vue';
import { files as api } from '@/api';
import buttons from '@/utils/buttons';
import { ROUTES } from '@/router';

export default {
  name: 'copy',
  components: { FileList },
  data: function () {
    return {
      current: window.location.pathname,
      dest: null
    };
  },
  computed: {
    ...mapState([
      'req',
      'selected',
      'linkSharedDrive'
    ]),
  },
  mounted () {
    this.setIsPrompt(true);
  },
  methods: {
    ...mapMutations(['setIsPrompt']),
    copy: async function (event) {
      event.preventDefault();
      buttons.loading('copy');
      let items = [];
      // Create a new promise for each file.
      for (let item of this.selected) {
        items.push({
          from: this.req.items[item].handle,
          to: this.dest
        });
      }

      document.getElementById('buttonCopy').disabled = true;
      document.getElementById('buttonCancelCopy').disabled = true;
      try {
        if (this.$route.name === ROUTES.DRIVE) {
          await api.copyId(items, ibbLink);
          let parentNode = await ibbLink.getNodeById(this.dest);
          if (parentNode.node.parentHandle === '') {
            this.$router.push({ path: this.$route.path + '#' + this.linkSharedDrive });
          } else {
            this.$router.push({ path: this.$route.path + '#' + this.dest });
          }
        } else {
          await api.copyId(items);
          this.$router.push({ path: this.$route.path + '#' + this.dest });
        }
        buttons.success('copy');
      } catch (e) {
        buttons.done('copy');
        this.$showError(e);
      }
    }
  },
  beforeDestroy () {
    this.setIsPrompt(false);
  }
};
</script>
